import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'
import {RepositoriesPageForNavigator} from './routes/RepositoriesPage'

registerNavigatorApp('repos-list', () => ({
  App,
  routes: [
    jsonRoute({path: '/orgs/:org/repositories', Component: RepositoriesPageForNavigator}),
    // This is a temporal route until we build a package for the user-repositories-finder, reusing most of the logic from the repos-list package.
    jsonRoute({path: '/repos', Component: RepositoriesPageForNavigator}),
  ],
}))
